import React from 'react';
import Hero from '../components/common/Hero';
import Button from '../components/common/Button';
import { exitReadyHero } from '../assets/images/imageImports';

const WhyExitReady = () => {
  return (
    <div className="why-exit-ready-page">
      <Hero
        title="SkySight ExitReady™"
        subtitle="A service that prepares financial and operational data for a clean, confident exit"
        buttonText="Who It's For"
        buttonLink="/who-its-for"
        backgroundImage={exitReadyHero}
      />
      
      <section className="section">
        <div className="container">
          <h2 className="section-title">Own Your Numbers. Command Your Valuation.</h2>
          <p className="text-center" style={{maxWidth: '800px', margin: '0 auto 3rem'}}>
            Preparing for a sale? The best exits aren't reactive—they're built on clean, credible data that withstands scrutiny. 
            SkySight ExitReady™, designed for sell-side advisors is your turnkey data preparation service that gives your client's company the clarity, control, and confidence 
            needed to remove the "Dirty Data Discount" and sail through due diligence and maximize value.
          </p>
          
          <div className="row">
            <div className="col-6">
              <div className="card">
                <h3>Why ExitReady™?</h3>
                <ul className="check-list">
                  <li><strong>Reduce Buyer Friction</strong><br />
                  Streamline the due diligence process by eliminating dirty data and financial inconsistencies across systems.</li>
                  
                  <li><strong>Boost Buyer Confidence</strong><br />
                  Deliver clean financials, aligned KPIs, and a fully auditable view of your business performance, in multiple views.</li>
                  
                  <li><strong>Drive a Premium Multiple</strong><br />
                  Buyers pay more when your data tells a consistent, verifiable growth story—ExitReady™ ensures it does, removing the dirty data discount.</li>
                  
                  <li><strong>Stay in Control of the Process</strong><br />
                  Avoid last-minute scrambles, deal delays, or reactive narrative shifts with a data foundation you trust.</li>
                </ul>
              </div>
            </div>
            <div className="col-6">
              <div className="card">
                <h3>What's Included</h3>
                <ul className="feature-list">
                  <li>A centralized, sell-side focused finance data warehouse</li>
                  
                  <li>Cross-system reconciliation (ERP, CRM, payroll, BI, etc.) across platforms like NetSuite, QuickBooks, Salesforce, and more</li>
                  
                  <li>Cleansed and structured data sets for key diligence metrics:
                    <ul>
                      <li>Revenue breakdowns, profitability and margin reporting, CAC, LTV, ARR / cohort analysis</li>
                    </ul>
                  </li>
                  
                  <li>VDR-ready reporting exports and buyer-friendly dashboards</li>
                  
                  <li>Optional buyer onboarding data package</li>
                </ul>
                <Button to="/contact" type="primary" style={{marginTop: '1rem'}}>Contact Us</Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section bg-light">
        <div className="container">
          <h2 className="section-title">Who It's For</h2>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">Founder-led firms</h3>
              <p>Aiming to exit within 12–24 months</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">CFOs</h3>
              <p>Preparing for strategic sale, PE recap, or M&A rollup</p>
            </div>
            <div className="feature">
              <div className="feature-icon">🔹</div>
              <h3 className="feature-title">Portfolio Companies</h3>
              <p>Seeking clean exit paths with minimal data risk</p>
            </div>
          </div>
          <div className="text-center" style={{marginTop: '2rem'}}>
            <Button to="/who-its-for" type="secondary" size="large">See Who We Serve</Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyExitReady;